export const hotelViewType: any = {
  oceanFront: "Ocean front",
  oceanView: "Ocean view",
  partialOceanView: "Partial ocean view",
  nothing: "Nothing",
};
